import { render, staticRenderFns } from "./TabContent.vue?vue&type=template&id=278ab3f6&scoped=true&"
import script from "./TabContent.vue?vue&type=script&lang=ts&"
export * from "./TabContent.vue?vue&type=script&lang=ts&"
import style0 from "./TabContent.vue?vue&type=style&index=0&id=278ab3f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278ab3f6",
  null
  
)

export default component.exports